import * as angular from 'angular';

(function () {
    'use strict';

    angular
        .module('app')
        .controller('IssueStatusController', IssueStatusController);

    function IssueStatusController() {}
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/issues/parts/issue-status/issue-status.controller.ts